module.exports = __webpack_public_path__ + "static/media/ic-cancel.171acb78.svg";